import { FC, useState } from 'react'

import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { FullScreenModal } from 'src/Components/FullScreenModal'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { useUpdateSpotifyCampaignAiUsageMutation } from 'src/Redux/spotify-campaignApi'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

import { AiUsageModalContent } from './AiUsageModalContent'

const StyledModal = styled(FullScreenModal)`
  height: 100%;
`

export const AiUsageModal: FC = () => {
  const { number: campaignId } = useParams<{ number: string }>()
  const { campaignDetails } = useSpotifyCampaignStatus()
  const { setSearch } = useCustomSearchParams()
  const [updateAiUsage, { isLoading }] =
    useUpdateSpotifyCampaignAiUsageMutation()
  const [value, setValue] = useState(campaignDetails?.aiUsage ?? null)

  const handleClose = (): void => {
    setSearch({ modal: null })
  }

  const handleConfirm = (): void => {
    if (!value || !campaignId) {
      return
    }
    updateAiUsage({ id: campaignId, aiUsage: value })
      .unwrap()
      .then(() => setSearch({ modal: null }))
      .catch(() => null)
  }

  return (
    <StyledModal
      showCloseButton
      onCancel={handleClose}
      prefixCls='aiUsage'
      open
    >
      <AiUsageModalContent
        value={value}
        isLoading={isLoading}
        onChange={setValue}
        onConfirm={handleConfirm}
        onClose={handleClose}
      />
    </StyledModal>
  )
}
